import {Component, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'app-briefe',
  standalone: true,
  imports: [
    MatIcon
  ],
  templateUrl: './briefe.component.html',
  styleUrl: './briefe.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BriefeComponent {

}
